import styled from 'styled-components';
import PropTypes from 'prop-types';
import React, { useCallback, useRef } from 'react';

const TextAreaWrapper = styled.textarea`
  /* border: none; */
  border: 1px solid ${props => props.theme.colors.primary};
  font-size: ${props => props.theme.fonts.sizeBase};
  padding: 10px;
  outline: none;
  font-family: ${props => props.theme.fonts.fontfaceBeta};
  line-height: 1em;
  width: 100%;
  min-height: 40px;
  height: 120px;
  -webkit-appearance: none;
  border-radius: 0;
  resize: vertical;
`;

function TextArea({ onChange, onFocus, onBlur, textValue = '', ...rest }) {
  const textInput = useRef(null);

  const handleChange = useCallback(
    e => {
      const newValue = e.target.value;
      if (onChange) onChange(newValue);
    },
    [onChange]
  );

  const handleBlur = useCallback(() => {
    if (onBlur) onBlur();
  }, [onBlur]);

  const handleFocus = useCallback(() => {
    if (onFocus) onFocus();
  }, [onFocus]);

  return (
    <TextAreaWrapper
      ref={textInput}
      value={textValue}
      onChange={handleChange}
      onBlur={handleBlur}
      onFocus={handleFocus}
      rows={3}
      {...rest}
    />
  );
}

TextArea.propTypes = {
  textValue: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func
};

export default TextArea;
